import React, { useEffect, useRef } from "react";
import { MapPin, Navigation } from "lucide-react";

const SearchLocationStep = ({
  locationQuery,
  onLocationQueryChange,
  locationSuggestions,
  loadingSuggestions,
  selectedLocation,
  onSelectSuggestion,
  onUseCurrentLocation,
  loadingCurrentLocation,
  locationError,
  onContinue,
  onSkip,
}) => {
  const inputRef = useRef(null);
  const canContinue = Boolean(selectedLocation);

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus({ preventScroll: true });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="search-location-step">
      <div className="search-location-step__intro">
        <h3 className="search-location-step__title">Where to eat?</h3>
        <p className="search-location-step__subtitle">
          Choose a nearby restaurant or skip to search everywhere.
        </p>
      </div>

      <div className="search-location-step__field">
        <div className="search-location-step__input-wrap">
          <MapPin
            size={20}
            strokeWidth={2}
            className="search-location-step__input-icon"
            aria-hidden="true"
          />
          <input
            ref={inputRef}
            type="text"
            className="search-location-step__input"
            placeholder="City, area, or postcode"
            value={locationQuery || ""}
            onChange={(e) => onLocationQueryChange(e.target.value)}
          />
        </div>

        {loadingSuggestions && (
          <div className="search-location-step__hint">Finding locations...</div>
        )}

        {!loadingSuggestions && locationSuggestions.length > 0 && (
          <ul className="search-location-step__suggestions">
            {locationSuggestions.map((item) => (
              <li key={item.id || item.cityName}>
                <button
                  type="button"
                  className="search-location-step__suggestion"
                  onClick={() => onSelectSuggestion(item)}
                >
                  <span>{item.cityName || item.name}</span>
                  {item.region && (
                    <small>
                      {[item.region, item.country].filter(Boolean).join(", ")}
                    </small>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="search-location-step__actions">
        <button
          type="button"
          className="search-location-step__geo-link"
          onClick={onUseCurrentLocation}
          disabled={loadingCurrentLocation}
        >
          <Navigation size={16} strokeWidth={2} aria-hidden="true" />
          {loadingCurrentLocation
            ? "Getting your location..."
            : "Use my current location"}
        </button>
        <span className="search-location-step__tag">Closest restaurants</span>
      </div>

      {locationError && (
        <div className="search-location-step__empty search-location-step__empty--error">
          {locationError}
        </div>
      )}

      <div className="search-location-step__footer">
        <button
          type="button"
          className="search-location-step__skip"
          onClick={onSkip}
        >
          Skip — search everywhere
        </button>
        <button
          type="button"
          className="search-location-step__continue"
          onClick={onContinue}
          disabled={!canContinue}
        >
          Continue to search
        </button>
      </div>
    </div>
  );
};

export default SearchLocationStep;
